import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const CoreCard = ({ child, width, height, minWidth, ...props }) => {
  return (
    <Card
      sx={{
        width: { width },
        minWidth: { minWidth },
        height: { height },
        borderRadius: "20px",
      }}
      elevation={4}
      {...props}
    >
      <CardContent className="p-4">{child}</CardContent>
    </Card>
  );
};

export default CoreCard;
